<style scoped>
.sso-button {
  text-transform: none;
  border-radius: 4px !important;
  margin-left: 10px;
  font-size: .7rem;
  font-weight: 500;
  color: #555;
  img {
    width: 20px;
    margin-right: 10px;
  }
}

.spaced-btn {
  margin-top: 24px;
  margin-bottom: 40px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 5px;
  align-items: center;
}

a {
  text-decoration: underline;
  color: #555 !important;
}

/* Enter and leave animations can use different */
/* durations and timing functions.              */
.slide-fade-enter-active {
  transition: all .3s ease;
}
.slide-fade-leave-active {
  transition: all .3s ease;
}
.slide-fade-enter, .slide-fade-leave-to
/* .slide-fade-leave-active below version 2.1.8 */ {
  transform: translateY(-20px);
  opacity: 0;
}
</style>

<template>
  <unauth-base-card tip="Welcome back! Please log into your account.">
    <transition name="slide-fade">
      <login-form v-if="isSystemLoginEnabled && showAnchorAuth" @success="onLoginSuccess" />
    </transition>
    <v-row>
      <v-col class="pt-0 pb-6" align="center">
        <div :class="{ 'spaced-btn': !showAnchorAuth }">
          <v-btn large class="sso-button elevation-0 unauth-action-btn" @click="microsoftLogin">
            <img src="@/assets/icons/ms-icon.svg" height="32"/>
            <span>Sign in with Microsoft</span>
          </v-btn>
        </div>
        <div v-if="!showAnchorAuth && isSystemLoginEnabled">
          <small>Or sign in with your Anchor Loans Login
          <a @click="showAnchorAuth = true">
            here
          </a>
        </small>
        </div>
      </v-col>
    </v-row>
  </unauth-base-card>
</template>

<script>
import { DEFINE_USER, DEFINE_ROOT, DEFINE_HAS_LOGGED_OUT } from '@/store/modules/user/actions';
import { DEFINE_LOADING } from '@/store/modules/app/actions';

import UnauthBaseCard from '@/components/unauth/UnauthBaseCard';

import LoginForm from './LoginForm';


export default {
  name: 'LoginCard',
  components: {
    UnauthBaseCard,
    LoginForm,
  },
  data: () => ({
    showAnchorAuth: false,
    isSystemLoginEnabled: false,
  }),
  methods: {
    googleLogin() {
      const { next } = this.$route.query;
      if (next) window.location.href = `/auth/googleLogin?next=${encodeURIComponent(next)}`;
      else window.location.href = '/auth/googleLogin';
    },
    microsoftLogin() {
      const { next } = this.$route.query;
      if (next) window.location.href = `/auth/microsoft-login?next=${encodeURIComponent(next)}`;
      else window.location.href = '/auth/microsoft-login';
    },
    onLoginSuccess(user) {
      this.$store.dispatch(DEFINE_ROOT, { root: null });
      this.$store.dispatch(DEFINE_HAS_LOGGED_OUT, { hasLoggedOut: false });
      this.$store.dispatch(DEFINE_USER, { user }).then(() => {
        const redirect = this.$route.query.next || this.$route.query.redirect;
        if (redirect) {
          if (redirect.startsWith('http')) {
            this.$store.dispatch(DEFINE_LOADING, { loading: true });
            window.location.href = redirect;
            return;
          }

          this.$router.push(redirect);
        } else {
          this.$router.push({ name: 'HomeView' });
        }
      });
    },
    fetchAuthConfig() {
      this.$requests.get('/auth/config').then(res => {
        this.isSystemLoginEnabled = res.data.isSystemLoginEnabled;
      }).catch(() => {
        this.isSystemLoginEnabled = false;
      });
    },
  },
  mounted() {
    if (this.$route.query.error) {
      this.$toast.error(this.$route.query.error, { timeout: 10000 });
    }
    this.fetchAuthConfig();
  },
};
</script>
